import { render, staticRenderFns } from "./addAdModel.vue?vue&type=template&id=96e44478&scoped=true&"
import script from "./addAdModel.vue?vue&type=script&lang=js&"
export * from "./addAdModel.vue?vue&type=script&lang=js&"
import style0 from "./addAdModel.vue?vue&type=style&index=0&id=96e44478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e44478",
  null
  
)

export default component.exports